import { h, Component } from 'preact';
import { Router } from 'preact-router';
import { Provider } from '@preact/prerender-data-provider';

// Code-splitting is automated for routes
import Home from '../routes/home';
import Contact from '../routes/contact';
import ContactSuccess from '../routes/contact-success';
import NotFoundPage from '../routes/notfound';
import About from '../routes/about';
import Gallery from '../routes/gallery';
import GalleryItem from '../routes/galleryItem';
import Locations from "../routes/locations";
import LocationGallery from "../routes/locationGallery";

export default class App extends Component {

	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = e => {
		this.currentUrl = e.url;
		this.appClass = e.url;
	};

	appClass = 'home';

	render(props) {
		return (
			<Provider value={props}>
				<div id="app" className={this.appClass}>
					<Router onChange={this.handleRoute}>
						<Home path="/" />
						<About path="/about/" />
						{/* <Locations path="/locations/" /> */}
						{/* <LocationGallery path="/locations/:name" /> */}
						{/* <GalleryItem path="/locations/:name/:name" /> */}
						<Gallery path="/gallery/" />
						<GalleryItem path="/gallery/:name" />
						<Contact path="/contact/" />
						<ContactSuccess path="/contact/success" />
						<NotFoundPage type="404" default />
					</Router>
				</div>
			</Provider>
		);
	}
}
